import {createHttpClient} from './HttpClient'

const apiCreate = (baseURL = 'http://localhost:3001') => {
    const api = createHttpClient({
        baseURL,
        headers: {
            'responseType': 'web'
            // 'Cache-Control': 'no-cache',
            // 'Access-Control-Allow-Origin': '*',
            // 'Accept': '*'
        },
        timeout: 5000000
    })

    const setHeader = api.setHeader
    const setHeaders = api.setHeaders

    const verifyUser = (data) => api.post('/auth', data)
    const registerUser = (data) => api.post('/users/register', data)
    const forgotUser = (data) => api.post('/users/forgotPassword', data)
    const resetUser = (data) => api.put('/users/password', data)
    const getUser = () => api.get('/users/me')
    const getUserProfile = () => api.get('/users/profile/current')
    const logoutUser = () => api.get('/users/logout')
    const getAllUserInfo = ({selectedRoleType, pageNumber, pageSize, searchText: q = undefined, filters = {}}) => api.get(`/users`, {
        role: selectedRoleType,
        page: pageNumber,
        q,
        limit: pageSize,
        status: filters.status
    })
    // only Riders no need to pass role
    const getAllAvailableRiders = ({selectedRoleType, pageNumber, pageSize, searchText: q = undefined, filters = {}, selectedCampaign = undefined}) => api.get(`/users/availableRiders`, {
        page: pageNumber,
        q,
        limit: pageSize,
        status: filters.status,
        patientType: filters.patientType,
        campaign: selectedCampaign
    })
    const getSpecificUserInfo = ({id}) => api.get(`/users/${id}`)
    const updateSpecificUserInfo = ({id, user}) => api.put(`/users/${id}`, user)
    const sendSpecificUserInvite = ({id}) => api.put(`/users/invite/${id}`)
    const updateUserPassword = ({password, newPassword}) => api.put(`/users/me/password`, {
        password,
        newPassword
    })

    const createUser = ({user}) => api.post('/users/create', user)

    const createMultipleUser = ({schoolId, parentsArray}) => api.post(`/users/multiple/${schoolId}`, [...parentsArray])
    const getAllPatients = ({pageNumber, pageSize, startDate = undefined}) => api.get(`/patients`, {
        page: pageNumber,
        limit: pageSize,
        startDate: startDate
    })
    const getPatientDocument = ({id, dbq, dbqId}) => api.get(`/patients/doc/${id}`, {dbq, dbqId})
    const getAllPatientInfo = ({pageNumber, pageSize, timeSlot, status, patientType, selectedCampaign = undefined}) => api.get(`/patients`, {
        page: pageNumber,
        limit: pageSize,
        timeSlot,
        status,
        patientType,
        campaign: selectedCampaign
    })

    const getPatient = ({id}) => api.get(`/patients/${id}`)
    const updateSpecificPatientInfo = (patient) => api.put(`/patients/${patient.id}`, patient)
    const updateSpecificPatientSignInfo = (patient) => api.put(`/patients/sign/${patient.id}`, patient)
    const createPatient = (patient) => api.post('/patients', patient)
    const clearAllPatients = ({selectedCampaign = undefined}) => api.delete(`/patients/all`)
    
    const getAllDbqs = () => api.get(`/dbq/all`)

    // need to send parameters
    const getCorrectedDbq = () => {        
        api.get(`/dbq/corrected/`)
    }

    return {
        setHeader,
        setHeaders,
        ...api,
        verifyUser,
        registerUser,
        forgotUser,
        resetUser,
        getUser,
        logoutUser,
        getAllUserInfo,
        getSpecificUserInfo,
        updateSpecificUserInfo,
        sendSpecificUserInvite,
        updateUserPassword,
        createUser,
        createMultipleUser,
        getAllAvailableRiders,
        getUserProfile,
        getAllPatientInfo,
        getAllPatients,
        getPatientDocument,
        getPatient,
        updateSpecificPatientInfo,
        updateSpecificPatientSignInfo,
        createPatient,
        clearAllPatients,
        getAllDbqs,
        getCorrectedDbq,
        // getPatientCorrectedDoc
    }
}

export default {
    apiCreate
}
